export enum ChartRange {
  'week' = 7,
  'month' = 30,
  'all' = 80,
}
